import React, { Component } from "react";
import { Table, Button, Popconfirm, Row, Col, Upload } from "antd";
// import { Icon }from 'antd'
// import { ExcelRenderer } from "react-excel-renderer";
import "antd/dist/antd.css";
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { Multiselect } from "multiselect-react-dropdown";
import { Spinner } from "react-bootstrap";
export default class Pincode extends Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    this.state = {
      single: "",
      pinId: "",
      updateStatus: false,
      categoryName: "",
      cityName: id,
      spinner: false,
      seletedData: {},
      isSelected: false,
      cols: [],
      rows: [],
      pincodes: [],
      errorMessage: null,
      columns: [
        {
          title: "LOCATION",
          dataIndex: "location",
          editable: true,
        },
        {
          title: "PINCODE",
          dataIndex: "pincode",
          editable: true,
        },
        {
          title: "STATE",
          dataIndex: "state",
          editable: true,
        },
        {
          title: "DISTRICT",
          dataIndex: "district",
          editable: true,
        },
      ],
    };
  }
  componentDidMount() {
    axios
      .get(
        `${Baseurl.baseurl}/go-pincode/get-districts/${localStorage.getItem(
          "sname"
        )}`
      )
      .then((response) => {
        if (response.data.districts) {
          response.data.districts.map((val) => {
            
            if (val.Name === this.state.cityName) {
              this.setState({ updateStatus: true });
              this.setState({ pinId: val._id });
            }
          });
        }
      })
      .catch((err) => console.log(err));
  }

  fileHandler = (fileList) => {
    let fileObj = fileList;
    if (!fileObj) {
      this.setState({
        errorMessage: "No file uploaded!",
      });
      return false;
    }
    // ExcelRenderer(fileObj, (err, resp) => {
    //   if (err) {
    //   } else {
    //     this.setState({ spinner: true });
    //     let newRows = [];
    //     resp.rows.slice(1).map((row, index) => {
    //       if (row && row != "undefined" && row != "") {
    //         newRows.push({
    //           key: index,
    //           location: row[0],
    //           pincode: row[1],
    //           state: row[2],
    //           district: row[3],
    //         });
    //       }
    //     });
    //     if (newRows.length === 0) {
    //       this.setState({
    //         errorMessage: "No data found in file!",
    //       });
    //       return false;
    //     } else {
    //       this.setState({
    //         cols: resp.cols,
    //         rows: newRows,
    //         errorMessage: null,
    //       });
    //     }
    //     var str = " ";
    //     for (var i = 0; i < Object.keys(this.state.rows).length; i++) {
    //       str += this.state.rows[i].pincode + ",";
    //       const fruits = str.split(",");
    //       this.setState({ pincodes: fruits });
    //     }
    //   }
    //   this.setState({ spinner: false });
    // });

    return false;
  };
  updateCategory = () => {
    let updateData = {
      category: this.state.categoryName,
    };
    axios
      .put(
        `${Baseurl.baseurl}/go-pincode/add-new-category/${this.state.pinId}`,
        updateData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Category Added ", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Ooops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => console.log(err));
  };
  submithandler = () => {
    var artical = {
      pinCode: this.state.pincodes,
      locationName: this.state.cityName,
      state: localStorage.getItem("sname"),
      category: this.state.categoryName,
    };
    axios
      .post(Baseurl.baseurl + "/go-pincode/add-pincode", artical)
      .then((response) => {
        if (response.data.status) {
          swal(
            "Pincodes Added Successfully",
            response.data.message,
            "success",
            { button: "Done", timer: 1000 }
          );
          this.setState({ rows: "" });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Try Again!",
            timer: 1000,
          });
        }
      })
      .catch((err) => console.log(err));
  };
  submithandler2 = () => {
    var artical = {
      pinCode: this.state.pincodes,
      locationName: this.state.cityName,
      state: localStorage.getItem("sname"),
    };
    axios
      .post(Baseurl.baseurl + "/go-pincode/add-pincode", artical)
      .then((response) => {
        if (response.data.status) {
          swal(
            "Pincodes Added Successfully",
            response.data.message,
            "success",
            { button: "Done", timer: 1000 }
          );
          this.setState({ rows: "" });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Try Again!",
            timer: 1000,
          });
        }
      })
      .catch((err) => console.log(err));
  };
  render() {
    const selection2 = (selectedValues) => {
      let vig = [];
      selectedValues.map((val) => {
        vig.push(val.category);
      });
      this.setState({ categoryName: vig });
    };

    const objectArray1 = [
      {
        category: "Go_Movers",
        title: "Go Movers",
      },
      { category: "Go_Food", title: "Go Food" },
      // { category: "Grossary", },
      { category: "Go_Taxi", title: "Go Taxi" },
      { category: "Go_Grocery", title: "Go Grocery" },
    ];
    // const rowSelection = {
    // 	onChange: this.onSelect,
    // }
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return (
          <>
            col
            <input />
          </>
        );
      }

      return {
        ...col,

        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });
    return (
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <button
            className="btn btn-primary float-right"
            onClick={() => {
              this.props.history.push(`/city/${localStorage.getItem("sname")}`);
            }}
          >
            Back
          </button>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="form-group  col-sm-3">
              <label>Geofence Name</label>
              <input
                type="text"
                value={this.state.cityName}
                className="form-control input-default"
                placeholder="Enter the Name"
                onChange={(e) => {
                  this.setState({ cityName: e.target.value });
                }}
              />
            </div>

            <div className="basic-form row ">
              <form>
                <div className="col-sm-12 mb-4" id="multiselect">
                  <label>Category</label>
                  <Multiselect
                    closeIcon="close"
                    options={objectArray1}
                    displayValue="title"
                    onSelect={selection2}
                  />
                </div>
              </form>
              <div className="mt-4">
                {this.state.updateStatus && (
                  <button
                    className="btn btn-primary mt-1"
                    onClick={this.updateCategory}
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
          {this.state.updateStatus && (
            <div className="row">
              <div className="form-group  col-sm-3">
                <label>Add Single Pincode</label>
                <input
                  type="text"
                  maxLength={6}
                  value={this.state.pincodes}
                  className="form-control input-default"
                  placeholder="Enter Pincode"
                  onChange={(e) => {
                    this.setState({ pincodes: e.target.value });
                  }}
                />
              </div>
              <div className="col-sm-4 mt-4">
                <button
                  className="btn btn-primary mt-1"
                  onClick={()=>{this.submithandler2()}}
                >
                  Update
                </button>
              </div>
            </div>
          )}
          {this.state.updateStatus ? (
            <small class="text-white mt-3">---------- OR ----------</small>
          ) : (
            <small class="text-white mt-3">
              After selecting category choose a excel file to upload
            </small>
          )}

          <div className="row">
            <div className="col-sm-5 mt-4">
              <Upload
                name="file"
                beforeUpload={this.fileHandler}
                onRemove={() => this.setState({ rows: [] })}
                multiple={false}
              >
                <Button>
                  {/* <Icon type="upload" /> */} Click to Upload Excel File
                </Button>
              </Upload>
            </div>
            <div className="mt-4 col-sm-12">
              {this.state.spinner ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <Table
                  onExpand={this.onExpand}
                  dataSource={this.state.rows}
                  columns={columns}
                />
              )}
            </div>
          </div>
          <button
            className="btn btn-primary float-right mt-4"
            onClick={() => this.submithandler()}
          >
            {" "}
            Submit{" "}
          </button>
        </div>
      </div>
    );
  }
}
